module.exports = __webpack_public_path__ + "static/media/info-kleding.cd14105a.jpeg";